@if (showLoader()) {
  <div
    class="loader-container"
    aria-busy="true"
    role="progressbar"
    aria-valuetext="Loading For The Record"
    @animateLoader
    *ifFeatureFlagEnabled="'enable-navigation-loader'"
  >
    <div class="line">
      <div class="indeterminate"></div>
    </div>
  </div>
}
